export default "__VITE_ASSET__01518640__"